import React from "react";

const TextBlock = ({ data, update, mode }) => {
  if (mode === "edit") {
    return (
      <textarea
        className="form-control"
        placeholder="Write something..."
        value={data.text}
        onChange={(e) => update({ text: e.target.value })}
      />
    );
  }

  return data.text ? (
    <p className="fs-5">{data.text}</p>
  ) : (
    <p className="text-muted fst-italic">Empty text block</p>
  );
};

export default TextBlock;